<template>
  <v-form ref="mainForm" v-model="valid">
    <CatalogueLive
      code="fc_ouinon"
      v-model="sas.sasEquivalence.desireAjouterFormationsContinues"
      :live="{ endpoint: 'sas-equivalence', cle: '6145', fileId: sas.sasEquivalence.id }"
    />
    <data-iterator
      :list="sas.sasFormationContinue"
      add-new-text="Ajouter une formation continue"
      :live="{ endpoint: 'sas-formation-continue', sasId: sas.id }"
      :icon="$getIcon('formationContinue')"
      :valids="valids"
      ref="dataIterator"
      :opqIf="estOui(sas.sasEquivalence.desireAjouterFormationsContinues)"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.typeDActiviteDeFormation }}</p>
        <p class="mb-0">{{ item.organismeDispensateur }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="fc_type" v-model="item.typeDActiviteDeFormation" :live="LiveSasFormationContinue(6702, item)" />
        <MemoLive code="fc_objectifs" v-model="item.objectifsDApprentissage" :live="LiveSasFormationContinue(6703, item)" />
        <NumberLive code="fc_duree" v-model="item.dureeEnHeures" :live="LiveSasFormationContinue(6704, item)" />
        <TextFieldLive code="fc_organisme" v-model="item.organismeDispensateur" :live="LiveSasFormationContinue(6705, item)" />
        <DatePickerLive code="fc_date" v-model="item.dateDeFormation" :live="LiveSasFormationContinue(6706, item)" />
        <CatalogueLive code="fc_pays" v-model="item.pays" :live="LiveSasFormationContinue(6707, item)" />
        <FileInput code="fc_preuve" :file="item.attestationDeFormation" :live="LiveSasFormationContinue(6708, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    LiveSasFormationContinue(cle, item) {
      return { endpoint: "sas-formation-continue", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>